interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyRegular = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-sm leading-5 lg:text-base lg:leading-6 ${className}`}>
            {children}
        </p>
    );
};